import { CaracPretModel } from "./caracPret.model";

export class PretListModel {
    caracPret : CaracPretModel;
}